import {MAX_ERROR_TIMEOUT} from "./constants/Constants";

class LoaderDummy {
    constructor() {
        this.view = null;
        this.isLoading = false;
    }

    setView(view){
        this.view = view;
    }

    setLoading(){
        this.isLoading = true;
        if(this.view)
            this.view.forceUpdate();

        if (window.errorTimeout)
            clearTimeout(window.errorTimeout)

        window.errorTimeout = setTimeout(() => {
            if (this.isLoading)
                alert("Проверьте своё интернет соединение и попробуйте обновить страницу");
        }, MAX_ERROR_TIMEOUT);
    }
    freeLoading(){
        this.isLoading = false;
        if(this.view)
            this.view.forceUpdate();

        clearTimeout(window.errorTimeout)
    }
}

export const LoaderObject = new LoaderDummy();
